/* eslint-disable react/button-has-type */
import './Home.css'
import React from 'react';
import ReactPixel from 'react-facebook-pixel';
import image1 from '../Media/sliming2.jpeg'
import Orderform from '../Orderform/Orderform';

function Landing() {
    const handleClick = () => {
        const targetElement = document.getElementById('targetSection');
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    };


    const options = {
        autoConfig: true, // set pixel's autoConfig
        debug: false, // enable logs
    };

    ReactPixel.init('658872116769207', options);
    ReactPixel.pageView();

    return (
        <div>
            <div className="container">
                <h1 className="main-heading">নিরাপদে ওজন কমান খুবই সহজেই</h1>
                <h1 className="sub-heading">১০ থেকে ১৫ কেজি ওজন কমান বিশ্ব সেরা পিওর স্লিমিং জুস খেয়ে</h1>
                <button className="call-to-action" onClick={handleClick}>
                    <span role="img" aria-label="down arrow">
                        ⬇️
                    </span>{' '}
                    অর্ডার করতে চাই
                </button>

                <div style={{ marginTop: '40px' }}>
                    <hr />
                    <h1 className='headingcolor'>পিউর স্লিমিং জুস</h1>
                    <h2 className='headingcolor'>৩ পিছ ৯০০ টাকা</h2>
                    <div className="imageContainer mt-3">
                        <img src={image1} alt="" className="image" />
                    </div>
                    <button className="call-to-action" onClick={handleClick}>
                        <span role="img" aria-label="down arrow">
                            ⬇️
                        </span>{' '}
                        এখনি অর্ডার করুন
                    </button>
                    <hr />
                </div>
            </div>
            <div >
                <div className="vdcontainer">
                    <h1 className="vdheading">বিস্তারিত জানতে ভিডিওটি দেখুন</h1>

                    <div className="videoResponsive">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/kf6hyFX5Cp0" // Replace with your video ID
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        />
                    </div>
                    <div >
                        <button className="call-to-action" onClick={handleClick}>
                            <span role="img" aria-label="down arrow">
                                ⬇️
                            </span>{' '}
                            এখনি অর্ডার করুন
                        </button>
                    </div>
                </div>

            </div>

            <hr />


            <div>
                (
                <div className="benefits-wrapper">
                    <h2 className="title">পিউর স্লিমিং জুস এ কী কী উপকার পাবেন, স্থায়ীভাবে</h2>
                    <div className="divider" />

                    <div className="cards-container">
                        {/* Left Box */}
                        <div className="card">
                            <h3 className="card-title green-text">পিড্র লিমিং জুস এর উপকারীতাঃ</h3>
                            <ul className="list">
                                <li>✅ অতিরিক্ত মেদ ভুরি ও ওজন কমাতে ৭ দিনের মধ্যে</li>
                                <li>✅ পুরো শরীরের চর্বি/মেদ কমায়</li>
                                <li>✅ হরমোন ও থাইরয়েডের সমস্যা ব্যালেন্স করে আনে</li>
                                <li>✅ অতিরিক্ত ওজন এর ফলে, উচ্চরক্তচাপ, ডায়াবেটিস ও হৃদরোগ হয় যা, ইনশাআল্লাহ নিয়ন্ত্রণে আসে</li>
                                <li>✅ হাত পায়ের গাঁটুলি ও কোমর ব্যাথা দূর করে</li>
                                <li>✅ অতিরিক্ত ওজন কমিয়ে ফিটনেস ঠিক রাখতে সাহায্য করে</li>
                                <li>✅ ছেলেদের স্থিতিশীলতা উন্নত করে টেস্ট টোন উৎপন্ন করে</li>
                            </ul>
                        </div>

                        {/* Right Box */}
                        <div className="card">
                            <h3 className="card-title green-text">আমাদের কাছে থেকে কেন কিনবেন?</h3>
                            <ul className="list">
                                <li>
                                    ✅ <span className="highlight orange">নিরাপদ পেমেন্ট পদ্ধতি</span> - পন্য হাতে পেয়ে পেমেন্ট পরিবর্তন করার সুবিধা।
                                </li>
                                <li>
                                    ✅ <span className="highlight green">সুপ্রতিষ্ঠিত ডেলিভারি</span> - ২/৩ দিনের মধ্যে পন্য আপনার ঠিকানায় পৌঁছে যাবে।
                                </li>
                                <li>
                                    ✅ <span className="highlight yellow">১০০% ন্যাচারাল</span> - শতভাগ অরিজিনাল পণ্যের নিশ্চয়তা।
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="course-cards-container">
                
                    <CourseCard
                        title="দুই মাসের কোর্স"
                        description="আপনি যদি 12 থেকে 15 কেজি ওজন কমাতে চান তাহলে আমাদের দুই মাসের প্যাকেজটি। দুই প্যাকেট দুই মাসের কোর্সটি নিতে হবে।"
                        buttonText="অর্ডার করতে চাই"
                    />
                    <CourseCard
                        title="তিন মাসের কোর্স"
                        description="আপনি যদি 15 থেকে 20 কেজি ওজন কমাতে চান তাহলে আমাদের তিন মাসের প্যাকেজটি। তিন প্যাকেট তিন মাসের কোর্সটি নিতে পারেন।"
                        buttonText="অর্ডার করতে চাই"
                    />
                </div>
            </div>
            <div>
                <div className="fourcontainer">
                    <h1 className="warning">সাবধান</h1>
                    <p className="fourtext">
                        সাবধান! বাজারে অন্য জায়গা থেকে কম দামে নকল পন্য নিয়ে প্রতারিত হবেন না। অরিজিনাল অর্গানিক &quot;Pure
                        Slimming Juice&quot; এর চেয়ে কমে দেয়া সম্ভব না। তাই যদি কেউ অন্য জায়গায় কম দেখে বিভ্রান্ত হবেন না।
                    </p>
                </div>
            </div>

            <div>
                <div className='fivecontainer'>
                    <h2 className='fivephone'>যে কোন প্রয়োজনে ফোন করুন: 01325406296</h2>
                    <a href='tel:01325406296' className='callNowButton'>
                        <span className="callIcon">
                            {/* Replace with a proper phone icon if available */}
                            📞
                        </span>
                        Call Now
                    </a>
                </div>
            </div>


            <div id="targetSection" className="targetSection">
                t
                <Orderform />
            </div>
        </div>
    );
}

export default Landing;



function CourseCard({ title, description, buttonText }) {
    const handleClick = () => {
        const targetElement = document.getElementById('targetSection');
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="course-card">
            <h3 className="course-title">{title}</h3>
            <p className="course-description">{description}</p>
            <button onClick={handleClick} className="enroll-button">{buttonText}</button>
        </div>
    );
}